import { Reveal, Eyebrow } from "@/components/Reveal";
import CTABand from "@/components/CTABand";
import Seo from "@/components/Seo";

export default function Commercial() {
  return (
    <div data-testid="commercial-page">
      <Seo
        title="Commercial Landscaping and Property Management Services, Legacy Scapes Ltd"
        description="Tailored landscaping contracts for commercial and property management clients across the St. Clair Corridor."
      />

      <section className="bg-[#043B1C] pt-[76px]">
        <div className="mx-auto max-w-[1160px] px-5 py-16 md:px-8 md:py-24">
          <Reveal>
            <Eyebrow light>For commercial &amp; property management</Eyebrow>
            <h1 className="mt-4 max-w-3xl text-4xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl" data-testid="commercial-headline">
              Commercial &amp; Property Management
            </h1>
            <p className="mt-4 text-lg font-bold text-[#F4BE36] md:text-xl" data-testid="commercial-subhead">
              Professional property care. Dependable partnerships.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-white">
        <div className="mx-auto grid max-w-[1160px] items-center gap-12 px-5 py-16 md:px-8 md:py-24 lg:grid-cols-2 lg:gap-16">
          <div>
            <Reveal>
              <div className="space-y-4 text-base leading-[1.7] text-[#5B6B60]">
                <p>
                  Legacy Scapes provides professional lawn care, landscaping, and seasonal
                  maintenance for commercial properties, residential complexes, and managed
                  portfolios throughout the St. Clair River corridor.
                </p>
                <p>
                  We understand that property managers and commercial owners need more than quality
                  work. They need dependable scheduling, clear communication, and a contractor who
                  takes ownership of the services they provide. We work with each client to
                  establish practical maintenance plans, clear expectations, and consistent
                  communication that keeps properties looking their best.
                </p>
                <p>
                  Whether you manage a single commercial property or a portfolio of residential
                  buildings, our goal is to make exterior maintenance straightforward, reliable,
                  and one less thing on your list.
                </p>
              </div>
            </Reveal>
          </div>
          <Reveal>
            <div className="overflow-hidden rounded-2xl">
              <img
                src="/images/commercial-lawn.webp"
                alt="Freshly striped commercial lawn with a metal barn in the background"
                loading="lazy"
                className="aspect-[4/3] w-full object-cover"
                data-testid="commercial-photo"
              />
            </div>
          </Reveal>
        </div>
      </section>

      <CTABand heading="Let's discuss your property's needs." buttonText="Request a Consultation" />
    </div>
  );
}
